// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DealTypeInputFields, DealTypeInputs, DealTypeLabels } from '@interfaces/create-deal-inputs.interface';

@Component({
    selector: 'deal-type',
    templateUrl: './deal-type.component.html',
    styleUrls: ['./deal-type.component.scss'],
})
export class DealTypeComponent {
    @Input() dealTypeSelections: DealTypeInputs;
    @Output() completeDealType$ = new EventEmitter<DealTypeInputs>();
    dealTypeInputNames = Object.keys(DealTypeInputFields).map((name) => DealTypeInputFields[name]);
    dealTypeLabels = DealTypeLabels;

    setDealTypeInput(inputName: DealTypeInputFields, isTrue: boolean): void {
        this.dealTypeSelections[inputName] = isTrue;
    }
}
